import ProductBenefitsSummary from 'quick-quote/product-common/benefit-illustration/components/product-benefits/product-benefits-summary'
import ProductBenefitsContent from './product-benefits-content'
import LifeProtect18ProductBenefits from 'quick-quote/product-whole-life/benefit-illustration/components/product-benefits/product-benefits-lifeprotect18'
import LifeEnsureProductBenefits from 'quick-quote/product-whole-life/benefit-illustration/components/product-benefits/product-benefits-lifeEnsure'
import IProtectProductBenefits from 'quick-quote/product-whole-life/benefit-illustration/components/product-benefits/product-benefits-iprotect'
import LifeLegacyBenefits from 'quick-quote/product-whole-life/benefit-illustration/components/product-benefits/product-benefits-lifeLegacy'

const ProductBenefits = ({
  displayProduct,
  sumAssured,
  basicPremium,
  calculatedPaymentPeriod,
  calculatedCoveragePeriod,
  policyValue,
  benefitSummaryHeader,
}) => {
  return (
    <div id="product-benefits" className="benefit group">
      <ProductBenefitsSummary
        displayProduct={displayProduct}
        sumAssured={sumAssured}
        basicPremium={basicPremium}
        calculatedPaymentPeriod={calculatedPaymentPeriod}
        calculatedCoveragePeriod={calculatedCoveragePeriod}
        policyValue={policyValue}
        benefitSummaryHeader={benefitSummaryHeader}
      />

      <ProductBenefitsContent displayProduct={displayProduct} />

      <LifeProtect18ProductBenefits displayProduct={displayProduct} sumAssured={sumAssured} />

      <LifeEnsureProductBenefits displayProduct={displayProduct} />

      <IProtectProductBenefits displayProduct={displayProduct} sumAssured={sumAssured} />

      <LifeLegacyBenefits displayProduct={displayProduct} />
    </div>
  )
}

export default ProductBenefits
